import { NgModule } from '@angular/core';
import { IonicPageModule } from 'ionic-angular';
import { LogEventsPage } from './log-events';
import { DirectivesModule } from '../../../directives/directives.module';

@NgModule({
  declarations: [
    LogEventsPage,
  ],
  imports: [
    DirectivesModule,
    IonicPageModule.forChild(LogEventsPage),
  ],
})
export class LogEventsPageModule {
}



// WEBPACK FOOTER //
// ./src/pages/daily-log/log-events/log-events.module.ts